import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-normal-person',
  templateUrl: './normal-person.component.html',
  styleUrls: ['./normal-person.component.css']
})
export class NormalPersonComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    document.documentElement.scrollTop = 0;
  }

}
